var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckboxBlanki = function SvgCheckboxBlanki(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "checkbox-blank_i_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#checkbox-blank_i_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 3.7h14A1.3 1.3 0 0 1 20.3 5v14a1.3 1.3 0 0 1-1.3 1.3H5A1.3 1.3 0 0 1 3.7 19V5A1.3 1.3 0 0 1 5 3.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dfe2e5",
    d: "M19 19.6a.6.6 0 0 0 .6-.6V5a.6.6 0 0 0-.6-.6H5a.6.6 0 0 0-.6.6v14c0 .33.27.6.6.6zm0 1.4H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckboxBlanki);
export default ForwardRef;